import { useEffect, useRef, useState } from 'react';
import { MapSearchBoxProps } from './types';
import SearchInput from './SearchInput';
import useMapSearchBoxStyles from './styles';
import { MapSearchResult } from 'kinetic/modules';
import { MapSearchBoxContext } from 'components/maps';
import { MapSearchHistory } from './MapSearchHistory';
import { MapboxSuggestions } from './MapboxSuggestions';
import { useRenderLazy } from 'kinetic/useRenderLazy';

export const MapSearchBox: React.FC<MapSearchBoxProps> = (props) => {
  const { searchBoxPosition = 'top-left', topOffset = 0 } = props;
  const classes = useMapSearchBoxStyles({ searchBoxPosition, topOffset });

  const mapSearchResults = useRenderLazy({ imports: MapSearchResult });

  const [focusedSearchField, setFocusedSearchField] = useState(false);
  const [searchText, setSearchText] = useState('');
  const searchFocusTimeout = useRef<ReturnType<typeof setTimeout>>();

  const onSearchInputFocus = (focused: boolean) => {
    searchFocusTimeout.current = setTimeout(() => {
      setFocusedSearchField(focused);
    }, 200);
  };

  useEffect(() => {
    return () => {
      if (searchFocusTimeout.current) {
        clearTimeout(searchFocusTimeout.current);
      }
    };
  });

  const renderSearchInput = () => {
    return (
      <SearchInput
        onSearchInputFocus={onSearchInputFocus}
        value={searchText}
        onChange={(event) => setSearchText(event.target.value)}
      />
    );
  };

  return (
    <MapSearchBoxContext.Provider
      value={{
        searchText,
        setSearchText,
        searchBoxPosition,
      }}
    >
      <div className={classes.searchBoxWrapper}>
        {searchBoxPosition === 'top-right' || searchBoxPosition === 'top-left'
          ? renderSearchInput()
          : null}
        <div className={classes.listItemsWrapper}>
          <MapboxSuggestions />
          {searchText?.length && mapSearchResults?.length ? mapSearchResults : null}
          {focusedSearchField ? <MapSearchHistory /> : null}
        </div>
        {searchBoxPosition === 'bottom-right' || searchBoxPosition === 'bottom-left'
          ? renderSearchInput()
          : null}
      </div>
    </MapSearchBoxContext.Provider>
  );
};
